import { Lang } from "~/stores/locales/types";
import type { SeoData, SeoItem } from "~/stores/seo/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useSeoStore = defineStore("seo", () => {
  const seo: Ref<SeoItem[]> = ref<SeoItem[]>([]);

  async function fetchSeo () {
    const data: any = await $fetch(`${useRuntimeConfig().public.api_host}api/seo`);
    return seo.value = data;
  }

  function getSeoDataBySectionId(sectionId: number, lang: Lang): SeoData {
    const seoItem: SeoItem|undefined = seo.value.find(
      (item: SeoItem): boolean => sectionId === item.seo_section_id
    );

    if (!seoItem) {
      throw new Error(`В SEO данных нет элемента с секцией у которой ID равен ${sectionId}!`);
    }

    return {
      title: seoItem.title[0][lang],
      description: seoItem.description[0][lang],
      image: useRuntimeConfig().public.storage_host + seoItem.image_url,
    }
  }

  return { seo, getSeoDataBySectionId, fetchSeo };
});
